// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IUpdateParams } from ".";
import styled from "@emotion/styled";
import { useCallback, useEffect, useRef, useState } from "react";
import * as React from "react";
import { Editor, Element, Node, Path, Range, Transforms } from "slate";
import { ReactEditor, useSlate } from "slate-react";

import { Button, FormField, Input, SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { trackEngagement } from "helpers/analytics";
import { normalizeBrowserLink } from "utils/string";

import { LinkElement } from "../types";

import { LinkButtonGroup } from "./shared";

const FormLinkButton = styled(Button)`
  flex-shrink: 0;

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    margin-top: 8px;
    margin-left: 0;
  }
`;

const LinkForm: React.FC<{ params: IUpdateParams; eventPlace?: string; closeUI: () => void }> = ({
  params,
  eventPlace,
  closeUI,
}) => {
  const editor = useSlate();

  const [linkElement] = Editor.nodes(editor, {
    // @ts-expect-error TS(2322)
    at: params.selection.current,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    match: (node: any) => Element.isElement(node) && node.type === "link",
  });

  const [linkError, setLinkError] = useState(false);

  // @ts-expect-error TS(18047)
  const linkText = params.selection.current ? Editor.string(editor, params.selection.current) : "";

  const [url, setUrl] = useState<string>((linkElement && (linkElement[0] as LinkElement).url) || "");
  const [text, setText] = useState<string>(linkText || "");

  const urlEmpty = url.trim().length === 0;
  const textEmpty = text.trim().length === 0;

  const handleTextChange = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      setText(event.target.value);
    },
    [setText]
  );
  const handleUrlChange = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      setUrl(event.target.value);
      setLinkError(false);
    },
    [setUrl]
  );

  const handleLinkAdd = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      event.preventDefault();
      event.stopPropagation();
      const textValue = textEmpty ? url : text;
      const { success, url: resultURL } = normalizeBrowserLink(url);

      if (!success) {
        setLinkError(true);
        return;
      }

      trackEngagement("Editor: Link added", eventPlace, { source: "ui" });

      const normalizedURL = resultURL.trim();

      ReactEditor.focus(editor);
      if (linkElement) {
        Editor.withoutNormalizing(editor, () => {
          Transforms.setNodes(
            editor,
            { url: normalizedURL },
            { at: linkElement[1], match: Element.isElement, split: false }
          );
          // @ts-expect-error TS(2322)
          Transforms.insertText(editor, textValue, { at: params.selection.current });
          Transforms.select(editor, Editor.end(editor, linkElement[1]));
        });
      } else {
        Editor.withoutNormalizing(editor, () => {
          const targetSelection =
            // @ts-expect-error TS(18047)
            params.selection.current || Editor.range(editor, Editor.start(editor, []), Editor.start(editor, []));

          Transforms.select(editor, targetSelection);

          if (Range.isExpanded(targetSelection)) {
            Transforms.wrapNodes(
              editor,
              { type: "link", url: normalizedURL, children: [] },
              { at: targetSelection, split: true }
            );
          } else {
            Transforms.insertNodes(
              editor,
              { type: "link", url: normalizedURL, children: [{ text: textValue }] },
              { at: targetSelection }
            );
          }

          const [newNode] = Editor.nodes(editor, {
            at: Path.parent(targetSelection.anchor.path),
            // FIXME: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            match: (node: any) =>
              Element.isElement(node) &&
              node.type === "link" &&
              (node as LinkElement).url.replace(/^https?:\/\//, "") === url.replace(/^https?:\/\//, "") &&
              Node.string(node) === textValue,
            mode: "lowest",
          });
          // @ts-expect-error TS(18047)
          params.selection.unref();

          if (newNode) {
            Transforms.select(editor, Editor.end(editor, newNode[1]));
          }
        });
      }
    },
    [textEmpty, url, text, editor, linkElement, params.selection]
  );

  const textRef = useRef<HTMLInputElement | null>(null);
  const urlRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      if (!urlRef.current || !textRef.current) {
        return;
      }

      urlRef.current.focus();
    }, 100);
  }, [params.focusDisplayName]);

  return (
    <form onSubmit={handleLinkAdd}>
      <InputWrapper error={linkError ? "Use a URL link format such as https://website.com" : undefined} labelText="URL">
        <Input id="link-url" value={url} onChange={handleUrlChange} ref={urlRef} error={linkError} />
      </InputWrapper>
      <InputWrapper labelText="Display text">
        <Input id="link-text" value={text} onChange={handleTextChange} ref={textRef} placeholder={url} />
      </InputWrapper>
      <LinkButtonGroup>
        <FormLinkButton kind="secondary" size="compact" onClick={closeUI}>
          Cancel
        </FormLinkButton>
        <FormLinkButton kind="primary" size="compact" type="submit" disabled={urlEmpty || linkError}>
          Apply
        </FormLinkButton>
      </LinkButtonGroup>
    </form>
  );
};

const InputWrapper = styled(FormField)`
  min-width: 250px;
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export default LinkForm;
